import React from "react";
import { Element } from 'react-scroll';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from "./components/Header";
import About from "./components/About";
import Menu from "./components/Menu";
import Clients from "./components/Clients";
import Chat from "./chat/Chat";
import Products from "./components/Product";
import { productData } from "./components/data";
import Navbar from "./pages/navbar/Navbar";
import { Helmet } from "react-helmet-async";
import Heading1 from "./components/Heading1";
import Heading2 from "./components/Heading2";


function App() {
  return (
    <>
      <Helmet>
        <title>Home</title>
        <meta name="description" content="toko kue ulang tahun terdekat dari lokasi saya dan harganya murah || Pemesanan Kue Ulang Tahun yang Banyak Diminati | Temukan kue ulang tahun yang 
      sempurna untuk merayakan momen istimewa Anda. Di RazqaCake, kami bangga menyediakan pilihan kue ulang tahun yang tidak hanya lezat, tetapi 
      juga memikat hati."/>
      <link rel="canonical" href="/"/>
      </Helmet>
      <Header />
      <About />
      <Heading1 />
      <Menu />
      <Clients />
      <Products heading="Product List" data={productData} />
      <Heading2/>
      <Chat />
    </>

  );
}


export default App;
